/**
 * Authentication utility functions for localStorage management
 */

/**
 * Clears all authentication-related data from localStorage
 * Used when navigating to login page to ensure a fresh login state
 */
export const clearAuthData = () => {
  const itemsToRemove = [
    "prevPage",
    "webinarPendingRegistration",
    "authUsername",
    "products",
    "lastUsedAuth",
    "authProvider"
  ];
  
  itemsToRemove.forEach(item => localStorage.removeItem(item));
};

/**
 * Clears only user session data from localStorage
 * Used during logout to maintain certain preferences
 */
export const clearSessionData = () => {
  const itemsToRemove = [
    "authUsername",
    "prevPage",
    "products"
  ];
  
  itemsToRemove.forEach(item => localStorage.removeItem(item));
};
